<template>
    <div>
        <div>
            <form name="saForm" method="post" action="#">
                <input type="hidden" name="mid" v-model="mid">
                <input type="hidden" name="reqSvcCd" v-model="reqSvcCd">
                <input type="hidden" name="identifier" v-model="identifier">
                <input type="hidden" name="mTxId" v-model="mTxId">
                <input type="hidden" name="authHash" v-model="authHash">
                <input type="hidden" name="flgFixedUser" v-model="flgFixedUser">
                <input type="hidden" name="userName" v-model="userName">
                <input type="hidden" name="userPhone" v-model="userPhone">
                <input type="hidden" name="userBirth" v-model="userBirth">
                <input type="hidden" name="userHash" v-model="userHash"> 
                <input type="hidden" name="reservedMsg" v-model="reservedMsg">               		
                <input type="hidden" name="directAgency" v-model="directAgency">                                                        
                <input type="hidden" name="successUrl" v-model="successUrl">
                <input type="hidden" name="failUrl" v-model="failUrl">
            </form>
        </div>
        <v-dialog/>
    </div>
</template>

<script>
import { getInicisEncrypt } from '@/api/step3/identificationVerfication'
export default {
    name: "CallInicisAuthPop",
    data() {
        return {
            mid:'',
            reqSvcCd: '',
            mTxId: '',
            identifier:'',
            authHash: '',
            flgFixedUser: '',
            userName: '',
            userPhone: '',
            userBirth: '',
            userHash: '',
            reservedMsg: '',
            directAgency: '',
            successUrl: '',
            failUrl: '',

        }

    },
    created() {
        this.getInfo();
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : 통합인증 정보
         **/
        getInfo() {
  
            var url = location.href;
            var inicis_url = "https://sa.inicis.com/auth";
            if(url.indexOf("stg") != -1 || url.indexOf("local") != -1) {
                   inicis_url="https://stgsa.inicis.com/auth";
            }

            getInicisEncrypt(opener.authdata).then(res => {
            
                if(res.data.reqRsltCode !== "FAIL"){
                    
                    if(res.data.mtxId!==""){
                        this.reqSvcCd=res.data.reqSvcCd
                        this.mid=res.data.mid
                        this.mTxId=res.data.mtxId
                        this.identifier=res.data.onetMblAppfNo
                        this.authHash=res.data.authHash
                        this.flgFixedUser=res.data.flgFixedUser
                        this.userName=res.data.userName
                        this.userPhone=res.data.userPhone
                        this.userBirth=res.data.userBirth
                        this.userHash=res.data.userHash
                        this.reservedMsg=res.data.reservedMsg
                        this.directAgency=res.data.directAgency
                        this.successUrl=res.data.successUrl
                        this.failUrl=res.data.failUrl
                        this.$nextTick(() => {                             
                            //document.saForm.action = 'https://stgsa.inicis.com/auth'
                            document.saForm.action = inicis_url
                            document.saForm.submit();
                        })
                    }else{
                        this.openAlert('인증 오류', '인증정보가 올바르지 않습니다.')
                       
                    }
                }else{
                      this.openAlert('인증 오류', res.data.reqRsltMsg)
                     
                }
            }).catch(error => {
                 
                 //
               // window.close()
            })
        },

        /**
       * Function    : openAlert
       * Description : 기본 alert 호출 함수 
       **/
        openAlert(title, message) {
            this.$modal.show('dialog', {
                title: title,
                text: message,
                buttons: [
                {
                    title: '확인',
                    class: 'primary-button',
                    handler: () => {
                        this.$modal.hide('dialog')
                        window.close()
                    }
                }
                ]
                
            })
            
        },
    },
}
</script>

<style scoped>

</style>